import { message } from 'antd';
import { useRef } from 'react';

export default function Upload({
  setFiles,
  files,
  limit,
  allowedFileTypes,
  disabled = false,
  children,
  multiple = false,
  onFileSet,
}) {
  const fileInput = useRef(null);

  const handleFileInputChange = (e) => {
    const uploadedFiles = e.target.files;
    if (!uploadedFiles?.length) return;

    const selectedFiles = Array.from(uploadedFiles);
    let newFiles = [];

    if (multiple) {
      const duplicateFiles = selectedFiles.filter((selectedFile) =>
        files.some((existingFile) => existingFile.name === selectedFile.name)
      );
      
      if (duplicateFiles.length > 0) {
        message.error({
          content: `The following files are already uploaded: ${duplicateFiles
            .map((file) => file.name)
            .join(', ')}`,
          duration: 5,
        });
        e.target.value = '';
        return;
      }

      if (limit && files.length + selectedFiles.length > limit) {
        message.error({
          content: `You can only upload up to ${limit} documents. Please upload important documents only.`,
          duration: 5,
        });
        e.target.value = '';
        return;
      }

      newFiles = [...files, ...selectedFiles];
      setFiles(newFiles);
    } else {
      newFiles = selectedFiles;
      setFiles(newFiles);
    }

    e.target.value = ''; 

    if (onFileSet && newFiles.length) {
      onFileSet(newFiles);
    }
  };

  const handleUploadClick = () => {
    const btn = fileInput.current;
    if (btn) {
      btn.click();
    }
  };

  return (
    <div onClick={handleUploadClick}>
      <input
        ref={fileInput}
        type="file"
        multiple={multiple}
        onChange={handleFileInputChange}
        accept={allowedFileTypes?.join(', ')}
        style={{ display: 'none' }}
        disabled={disabled}
      />
      {children}
    </div>
  );
}
